export default "__VITE_ASSET__BwJVen9e__"